import { action } from 'satcheljs';

export const onPublisherDeleted = action('onPublisherDeleted');
